import { Collapse, Grid } from "antd";
import { useTranslation } from "react-i18next";
import CaretDown from "../../../../assets/images/icons/CaretDown";
import { NormalBanner, Title } from "../../../../components";
import CustomRadioButton from "../../../../components/CustomRadioButton";
import { ALL_KEY } from "../../../../components/CustomRadioButton/enumerations/enumerations";
import { ContentWrapper } from "../../../../layouts/components";
import { FaqContainerProps, FaqResponse } from "../../data";
import SkeletonCollapse from "../SkeletonCollapse";
import "./style";
import styles from "./styleModule";

const FaqContainer = ({
  options,
  selectedCategory,
  onChange,
  loadingCategory,
  loadingList,
  faqList,
}: FaqContainerProps) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  return (
    <>
      <NormalBanner />
      <ContentWrapper>
        <div className={styles.faqContainer}>
          <Title title={t("faq.title.snow")} subtitle={t("faq.subtitle")} />
          <CustomRadioButton
            items={options}
            selectedValue={selectedCategory}
            onValueChange={onChange}
            loading={loadingCategory}
            wrapperStyle={styles.radioWrapper}
          />
          {loadingList ? (
            <SkeletonCollapse itemsCount={3} />
          ) : (
            <Collapse
              className={`custom-faq-collapse ${
                screens.md ? "" : screens.xs ? "small" : "mobile"
              }`}
              style={{ marginBottom: 100 }}
              bordered={false}
              items={faqList?.filter(
                (faq: FaqResponse) =>
                  faq.category_id === selectedCategory ||
                  selectedCategory === ALL_KEY
              )}
              expandIcon={({ isActive }) => (
                <CaretDown
                  className={`${styles.caretStyle} ${
                    screens.sm ? "" : styles.mobile
                  } ${isActive ? styles.active : ""}`}
                />
              )}
            />
          )}
        </div>
      </ContentWrapper>
    </>
  );
};

export default FaqContainer;
